// extracted by mini-css-extract-plugin
export default {"container":"WorldMap_container__b0Pq6","subheading":"WorldMap_subheading__SQV3K","secondary":"WorldMap_secondary__0wDdt","map":"WorldMap_map__BJHsp"};